// Copied from transition-web/src/hooks/useSignInState.ts
// TODO: Adapt for new types

import React from 'react'
import { SignInState } from '../../../pure-js/types/SignInTypes'
import { DEFAULT_SIGN_IN_STATE } from '../libs/SignInHelper'

export default function useSignInState() {
  const [signInState, setSignInState] = React.useState<SignInState>(DEFAULT_SIGN_IN_STATE)

  return {
    signInState,
    setSignInState
  }
}
